//Create dataStorage
const saveDataToStorage = (name, data) => {
	localStorage.setItem(name, data);
};

const getDataFromStorage = (name) => {
	return localStorage.getItem(name);
};

const admin_token_key = '@vetrina_admin';
export const storeAdminToken = (token) => saveDataToStorage(admin_token_key, token);
export const getAdminToken = () => getDataFromStorage(admin_token_key) ?? '';

export const adminIsLoggedIn = () => getDataFromStorage(admin_token_key)?.length > 0 ?? false;
export const removeAdminToken = () => localStorage.removeItem(admin_token_key);

export const saveUser = (userObject) => localStorage.setItem('user', JSON.stringify(userObject));
export const getSavedUser = () => JSON.parse(localStorage.getItem('user'));
export const removeSavedUser = () => localStorage.removeItem('user');


const user_preferences_key = 'user_preferences';
export function getUserPreferences() {
	const user_pref = localStorage.getItem(user_preferences_key);
	if (!user_pref) return {};
	try {
		const prefs = JSON.parse(user_pref);
		return prefs;
	} catch (e) {
		return {};
	}
}
export function saveUserPreferences(preferences) {
	localStorage.setItem(user_preferences_key, JSON.stringify(preferences));
}